import FormCheckbox from '../../atoms/FormCheckBox/FormCheckBox'
import FormGroup from '../../atoms/FormGroup/FormGroup'
import FormGroupInput from '../../atoms/FormGroupInput/FormGroupInput'
import FormInput from '../../atoms/FormInput/FormInput'
import FormGroupTextArea from '../../atoms/FormGroupTextArea/FormGroupTextArea'
import React, { useEffect } from 'react'
import { FIELD_TYPES } from '../../constants/hartu'

const ibanRegex = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/i

const HartuFacilityDynamicForm = ({ field, values, setFieldValue, lang }) => {
    const fieldName = field.name;
    const fieldType = field.type?.toUpperCase() ?? '';
    const fullFieldName = `dynamicValues.${fieldName}`;

    // Valor actual del campo dentro de dynamicValues
    const dynamicValue = values.dynamicValues?.[fieldName] ?? '';

    // Props comunes para todos los campos
    const commonProps = {
        id: fullFieldName,
        label: field.title,
        required: field.required,
        disabled: field.disabled ?? false,
        defaultValue: field.default_value ?? "",
    };

    React.useEffect(() => {
        if (
            fieldType === FIELD_TYPES.HIDDEN &&
            field.default_value !== undefined &&
            values.dynamicValues?.[fieldName] === undefined
        ) {
            setFieldValue(fullFieldName, field.default_value);
        }
    }, [fieldType, field.default_value, values.dynamicValues, fieldName, fullFieldName, setFieldValue]);

    switch (fieldType) {
        case FIELD_TYPES.TEXTBOX:
        case FIELD_TYPES.NUMBER:
            return (
                <FormGroupInput
                    {...commonProps}
                    type={field.type}
                    onChange={(e) => setFieldValue(fullFieldName, e.target.value)}
                    placeholder={field.placeholder}
                    autoComplete={fieldName}
                />
            );

        case FIELD_TYPES.TEXTAREA:
            return (
                <FormGroupTextArea
                    {...commonProps}
                    onChange={(e) => setFieldValue(fullFieldName, e.target.value)}
                    placeholder={field.placeholder}
                />
            );

        case FIELD_TYPES.DDL: {
            const options = field.values_json ? Object.entries(field.values_json) : [];

            return (
                <FormGroupInput
                    {...commonProps}
                    as="select"
                    onChange={(e) => setFieldValue(fullFieldName, e.target.value)}
                >
                    <option value="" disabled>
                        {field.placeholder || (lang === 'es' ? 'Seleccione una opción' : 'Hautatu aukera bat')}
                    </option>
                    {options.map(([key, value]) => (
                        <option key={key} value={key}>
                            {value}
                        </option>
                    ))}
                </FormGroupInput>
            );
        }

        case FIELD_TYPES.LABEL:
            return (
                <div className="hartuBookingform__label-only">
                    <label htmlFor={fullFieldName}>{field.title}</label>
                </div>
            );

        case FIELD_TYPES.HIDDEN:
            return null;

        case FIELD_TYPES.CUENTA_BANCARIA:
            return (
                <FormGroupInput
                    {...commonProps}
                    type="text"
                    onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setFieldValue(fullFieldName, value);
                    }}
                    placeholder={field.placeholder || 'ES00 0000 0000 0000 0000 0000'}
                    autoComplete="off"
                    inputMode="text"
                />
            );    

        case FIELD_TYPES.CHECKBOX:
            return (
                <FormGroup {...commonProps} className="hartuBookingform__checkbox">
                    <FormCheckbox
                        label={field.placeholder}
                        name={fullFieldName}
                        checked={!!dynamicValue}
                        onChange={() => setFieldValue(fullFieldName, !dynamicValue)}
                    />
                </FormGroup>
            );

        default:
            return <div>Campo tipo {field.type} no implementado</div>;
    }
};

export default HartuFacilityDynamicForm;